import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import reducers from './reducers';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import '../src/css/main.scss';
import { BrowserRouter } from 'react-router-dom';
import Root from './containers/Root'
import { Provider } from 'react-redux'
import { saveToSessionStorage, loadFromSessionStorage } from './helpers/Utils';

let initialState = {
    errorState: false,
    activePeriod: '',
    greaterRegions: "Global",
    selected: 9,
    positionselected: 0,
    marketselected: '',
    selectedWheelPosition: { selectedDefinition: 0, selectedWheelPosition: 0 },
    comparegreaterregion: "Americas",
    basepath : window.location.pathname 
};

const persistedState = loadFromSessionStorage()

if (persistedState) {
    if (performance.navigation.type === 1 && window.location.pathname !== "/") {
        initialState = persistedState
    }
}

// Note: this API requires redux@>=3.1.0
const store = createStore(
    reducers
    , initialState
    , applyMiddleware(thunk)
);

store.subscribe(() => saveToSessionStorage(store.getState()));

ReactDOM.render(
    <Provider store={store}>
       <BrowserRouter >
            <Root store={store} persistedState = {persistedState}/>
        </BrowserRouter>
    </Provider>
    , document.getElementById('rentcycleroot')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
